import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect } from 'react';
import { makeAutoObservable } from 'mobx';
class ScopeStore {
    constructor() {
        this.activeScope = 0;
        makeAutoObservable(this);
    }
    setActiveScope(id) {
        this.activeScope = id;
    }
}
const $scope = new ScopeStore();
const ScopeContext = createContext(null);
const ScopeProvider = ({ children }) => {
    const { scope } = useContext(ScopeContext);
    useEffect(() => {
        $scope.setActiveScope(scope + 1);
        return () => {
            $scope.setActiveScope(scope);
        };
    }, [scope]);
    return _jsx(ScopeContext.Provider, Object.assign({ value: { scope: scope + 1 } }, { children: children }));
};
const useIsActiveScope = () => {
    const context = useContext(ScopeContext);
    return context.scope === $scope.activeScope;
};
export { ScopeContext, ScopeProvider, useIsActiveScope };
